import CaretRightIcon from 'components/common/IconsV2/CaretRightIcon';
import useMartyContext from 'hooks/useMartyContext';
import { pageSizeChevronClasses, pageSizeClasses, pageSizeSelectClasses } from 'components/common/Pagination/Pagination.classes';
import type { PaginationPageSizeSelectProps } from 'components/common/Pagination/Pagination.types';

/**
 * "Items per page" selector — a labelled <select> with an overlaid caret. Paired with a pagination
 * control (e.g. PaginationGroup) so a consumer can change how many results load per page.
 */
export const PaginationPageSizeSelect = ({ pageSizeValues, value, label, onChange }: PaginationPageSizeSelectProps) => {
  const { testId } = useMartyContext();

  return (
    <div className={pageSizeClasses}>
      <label className="body-s" htmlFor="pageSize">
        {label}
      </label>
      <div className="relative">
        <select id="pageSize" className={pageSizeSelectClasses} data-test-id={testId('pageSize')} value={value} onChange={onChange}>
          {pageSizeValues.map((size, index) => (
            <option key={index} value={size}>
              {size}
            </option>
          ))}
        </select>
        <div className={pageSizeChevronClasses}>
          <CaretRightIcon className="rotate-90" size={24} />
        </div>
      </div>
    </div>
  );
};
